import Brief from '@/components/Brief/Brief'
import Hero from '@/components/Hero/Hero'
import AppLayout from '@/components/Layouts/AppLayout'
import Owner from '@/components/Onwer/Owner'
import Partners from '@/components/partners/Partners'
import Plans from '@/components/Plans/Plans'
import Rewards from '@/components/Rewarde/Rewards'
import Head from 'next/head'



export default function Home() {
  return (
    <>
      <Head>
        <title>
          B-Love Network App is a Crypto staking platform to Earn Rewards
        </title>
        <meta
          name='description'
          content='Spread Love, Earn Rewards. A smartphone app that lets you stake BLV
tokens, invite referrals and earn lovely rewards. Download B-love Network: Download App.'
        />
        <meta name='viewport' content='width=device-width, initial-scale=1' />
        <link rel='icon' href='/assets/Image/blove_favicon.png' />
      </Head>
      <AppLayout>
        <Hero />
        <Owner />
        <Rewards />
        <Brief />
        <Plans />
        <Partners />
      </AppLayout>
    </>
  )
}
